import React, { useState } from "react";
import { Autocomplete } from "@react-google-maps/api";

function BasicDetails({ formData,setFormData, handleChange, handleChange1 }) {
  const [autocomplete, setAutocomplete] = useState(null);

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const location = {
          formatted_address: place.formatted_address,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        };
  
        handleChange1({
          target: {
            name: "location",
            value: location,
            dataset: { section: "basicDetails" },
          },
        });
      }
    }
  };
  


  console.log(formData, "formDataformData")


   // Handle change specifically for location
   const handleLocationChange = (e) => {
    const { value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      basicDetails: {
        ...prevData.basicDetails,
        location: value ? { formatted_address: value } : {}, // Only update formatted_address
      },
    }));
  };
  

  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
       <style>
                {`
          /* Custom Styling for Autocomplete Dropdown */
          .pac-container {
            z-index: 1000 !important;
            max-width: 100% !important;
            width: auto !important;
            background-color: white !important;
            border: 1px solid #ccc !important;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            top: 290px !important;
          }

          /* Adjust the individual items in the dropdown */
          .pac-item {
            padding: 10px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          /* Hover effect for items */
          .pac-item:hover {
            background-color: #f0f0f0;
          }

          /* Focused item styling */
          .pac-item.pac-item-selected {
            background-color: #e0e0e0;
          }
        `}
            </style>
      <legend className="text-lg font-semibold px-2">Basic Details</legend>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 font-medium">Project Name</label>
          <input
            type="text"
            name="projectName"
            value={formData?.basicDetails?.projectName}
            onChange={handleChange1}
            data-section="basicDetails"
            placeholder="Enter project name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Project Builder/Developer</label>
          <input
            type="text"
            name="projectBuilder"
            value={formData?.basicDetails?.projectBuilder}
            onChange={handleChange1}
            data-section="basicDetails"
            placeholder="Enter builder/developer name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        {/* Google Maps Autocomplete for Location */}
        <div>
          <label className="block text-gray-700 font-medium">Location</label>
          <Autocomplete
            onLoad={(autoC) => setAutocomplete(autoC)}
            onPlaceChanged={onPlaceChanged}
          >
            <input
              type="text"
              name="location"
              value={formData?.basicDetails?.location?.formatted_address || ""}
              onChange={handleLocationChange}
              data-section="basicDetails"
              placeholder="Enter location"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </Autocomplete>
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Price (₹)</label>
          <input
            type="number"
            name="price"
            value={formData?.basicDetails?.price}
            onChange={handleChange1}
            data-section="basicDetails"
            placeholder="Enter price"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">BHK Type</label>
          <select
            name="bhkType"
            value={formData?.basicDetails?.bhkType}
            onChange={handleChange1}
            data-section="basicDetails" // 🟢 Pass section name
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          >
            <option value="">Select BHK Type</option>
            <option value="1 BHK">1 BHK</option>
            <option value="2 BHK">2 BHK</option>
            <option value="3 BHK">3 BHK</option>
            <option value="4 BHK">4 BHK</option>
          </select>
        </div>
      </div>
    </fieldset>
  );
}

export default BasicDetails;
